import { Link } from 'react-router-dom';
import { Shield, Mail, Phone, MapPin, Award } from 'lucide-react';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Shield className="h-8 w-8 text-amber-500" strokeWidth={1.5} />
              <div>
                <h3 className="font-heading text-xl font-semibold">Tamperis Solutions LLC</h3>
                <p className="text-amber-500 text-sm">From Faith to Freedom</p>
              </div>
            </div>
            <p className="text-slate-400 text-sm mb-4 max-w-md">
              Restoring financial freedom through ethical, transparent, and legally-compliant 
              Credit Restoration services. Take control of your credit and walk in freedom.
            </p>
            
            {/* Board Certified Badge */}
            <div className="flex items-center gap-2 mb-4 bg-slate-800 rounded-lg px-4 py-2 w-fit">
              <Award className="h-5 w-5 text-amber-500" />
              <span className="text-sm font-medium text-white">Board Certified Credit Consultant</span>
              <span className="text-xs text-amber-500 font-semibold">Since 2023</span>
            </div>
            
            <div className="flex flex-col gap-2 text-sm text-slate-400">
              <a href="mailto:support@tampsolution.com" className="flex items-center gap-2 hover:text-white transition-colors">
                <Mail className="h-4 w-4" />
                support@tampsolution.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/pricing" className="hover:text-white transition-colors">Pricing</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">Compliance</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>FCRA Compliant</li>
              <li>Metro 2® Compliant</li>
              <li>CROA Compliant</li>
              <li>
                <Link to="/policy" className="hover:text-white transition-colors">Privacy Policy</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>© {currentYear} Tamperis Solutions LLC. All rights reserved.</p>
            <p className="text-xs">
              Results may vary. We do not guarantee specific credit score increases or removal of all negative items.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
